import React from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListSubheader from "@material-ui/core/ListSubheader";
import LngDetector from 'i18next-browser-languagedetector';
import i18n from "./i18nextInit";
import "./languageSelect.css"
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// stock les différentes langue disponible pour le dropdown
const languageMap = {
  fr: { label: "FR", dir: "ltr", active: false },
  de: { label: "DE", dir: "ltr", active: false },
  nl: { label: "NL", dir: "ltr", active: false }
  

}; 

const LanguageSelect = () => {
  
  
  const selected = localStorage.getItem("i18nextLng") || "fr";
  const { t } = useTranslation();

  const [menuAnchor, setMenuAnchor] = React.useState(null);
  React.useEffect(() => {
    document.body.dir = languageMap[selected].dir;
  }, [menuAnchor, selected]);
  
  // affiche le drop down avec les langue
  return (
    
    <div className="d-flex justify-content-end align-items-center language-select-root">
      <Button onClick={({ currentTarget }) => setMenuAnchor(currentTarget)}>
      <a className="lng__text"> {languageMap[selected].label}</a>
        <ArrowDropDown  fontSize="small" />
      </Button>
      <Popover
        open={!!menuAnchor}
        anchorEl={menuAnchor}
        onClose={() => setMenuAnchor(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
      >
        <div> 
          <List> 
            <ListSubheader>{t("select_language")}</ListSubheader>
            {Object.keys(languageMap)?.map(item => (
              <ListItem
                button
                key={item}
                onClick={() => {
                  i18next.changeLanguage(item);
                  setMenuAnchor(null);
                }}
              >
                <span className="lng__text">{ languageMap[item].label}</span>
              </ListItem>
            ))}
          </List>
        </div>
      </Popover>
    </div>
  );
};

export default LanguageSelect;
